module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="b-footer-pages">\r\n</div>\r\n';

}
return __p
}